class Quiz {
  static createSession(details) {
    return {
      payload: { ...details },
      type: 'CREATE_QUIZ_SESSION',
    }
  }

  static completeSession(details) {
    return {
      payload: { ...details },
      type: 'COMPLETE_QUIZ_SESSION',
    }
  }

  static updateNode(id) {
    return {
      payload: {
        id,
      },
      type: 'UPDATE_NODE',
    }
  }

  static merge(quizDetails) {
    return {
      payload: { ...quizDetails },
      type: 'MERGE_QUIZ',
    }
  }
}
export default Quiz
